import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "12px",
};

const card = {
  padding: "16px",
  borderRadius: "16px",
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.1)",
  cursor: "pointer",
  transition: "0.2s",
  textAlign: "center"
};

function Giochi() {
  const { localeTag, tableId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tokenUrl = searchParams.get("token");

  const [tokenScaduto, setTokenScaduto] = useState(false);
  const [verificaTokenLoading, setVerificaTokenLoading] = useState(true);

  useEffect(() => {
    const verifica = async () => {
      try {
        if (!tokenUrl) {
          setTokenScaduto(true);
          setVerificaTokenLoading(false);
          return;
        }
        const tavoloRef = doc(db, "locali", localeTag, "tavoli", tableId);
        const snap = await getDoc(tavoloRef);
        if (!snap.exists()) {
          setTokenScaduto(true);
          setVerificaTokenLoading(false);
          return;
        }
        const data = snap.data();
        const tokenAttuale = data.tokenAttuale;
        if (!tokenAttuale || tokenUrl !== tokenAttuale) setTokenScaduto(true);
        setVerificaTokenLoading(false);
      } catch (err) {
        console.error("Errore verifica token Giochi:", err);
        setTokenScaduto(true);
        setVerificaTokenLoading(false);
      }
    };
    verifica();
  }, [tokenUrl, localeTag, tableId]);

  if (verificaTokenLoading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "var(--color-bg)", color: "var(--color-text)" }}>
        <p>Verifica sessione in corso...</p>
      </div>
    );
  }

  if (tokenScaduto) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #667eea, #764ba2)", color: "white", padding: "1.5rem", textAlign: "center" }}>
        <div style={{ background: "rgba(255,255,255,0.1)", padding: "40px", borderRadius: "20px", maxWidth: "400px" }}>
          <div style={{ fontSize: "4rem", marginBottom: "20px" }}>⏱️</div>
          <h2 style={{ marginBottom: "15px" }}>Sessione scaduta</h2>
          <p>L'ordine di questo tavolo è stato completato.<br /><br /><strong>Scansiona il QR del tavolo per iniziare una nuova sessione.</strong></p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "var(--color-bg)", display: "flex", justifyContent: "center", alignItems: "center", padding: "1.5rem", color: "var(--color-text)" }}>
      <div style={{ backgroundColor: "var(--color-surface)", padding: "1.5rem", borderRadius: "16px", maxWidth: "520px", width: "100%", textAlign: "center", boxShadow: "0 6px 20px rgba(0,0,0,0.25)" }}>

        <h2 style={{ marginTop: 0, marginBottom: "0.6rem", color: "var(--on-surface)" }}>
          🎉 Giochi del tavolo
        </h2>

        <p style={{ fontSize: "0.9rem", marginTop: 0, marginBottom: "1rem", color: "var(--color-muted)" }}>
          Tavolo <strong>{tableId}</strong> – Locale <strong>{localeTag}</strong>
        </p>

        <div style={grid}>
          {[
            { title: "Tris",               icon: "🕹",  desc: "Sfida un amico al tavolo",          path: `/tris/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Crucipuzzle",        icon: "🔤",  desc: "Trova parole del menu",             path: `/crucipuzzle/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Milionario del menù",icon: "💰",  desc: "Rispondi e vinci",                  path: `/milionario/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Memory",             icon: "🧠",  desc: "Allena la memoria culinaria",       path: `/memory/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "PiattoMan",          icon: "🍽️", desc: "Mangia i piatti, evita i pericoli", path: `/piattoman/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Chef Run",           icon: "👨‍🍳", desc: "Salta gli ostacoli e scappa!",    path: `/chefrun/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Angry Chef",         icon: "🍕",  desc: "Lancia piatti e abbatti i blocchi!", path: `/angrychef/${localeTag}/${tableId}?token=${tokenUrl}` },
            { title: "Scacchi",            icon: "♟️",  desc: "Sfida un amico a scacchi",          path: `/scacchi/${localeTag}/${tableId}?token=${tokenUrl}` },
          ].map((game, i) => (
            <div key={i} onClick={() => navigate(game.path)} style={card}>
              <div style={{ fontSize: "2rem" }}>{game.icon}</div>
              <h3 style={{ margin: "10px 0 5px" }}>{game.title}</h3>
              <p style={{ fontSize: "0.85rem", opacity: 0.7 }}>{game.desc}</p>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate(`/menu/${localeTag}/${tableId}?token=${tokenUrl}`)}
          style={{ ...btn, backgroundColor: "var(--accent)", marginTop: "1rem" }}
        >
          ← Torna al menù
        </button>
      </div>
    </div>
  );
}

const btn = {
  width: "100%",
  padding: "0.8rem",
  margin: "0.4rem 0",
  borderRadius: "10px",
  border: "none",
  fontSize: "1rem",
  fontWeight: "bold",
  cursor: "pointer",
  backgroundColor: "var(--primary)",
  color: "var(--primary-contrast)",
  boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
};

export default Giochi;
